export const splitArrayIntoRows = (arr, itemsInRow) => {
  return Array.from(
    { length: Math.ceil(arr.length / itemsInRow) },
    (_elem, i) => arr.slice(i * itemsInRow, i * itemsInRow + itemsInRow)
  )
}
